<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>防汛预案</h6>
			<el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">添加预案</el-button>
			<!-- <el-button class="titBtn" type="success" icon="el-icon-search">搜索</el-button> -->
			<!-- <el-input class="querys" v-model.trim="dw" placeholder="预案名称"></el-input> -->
      <addressTree @obj="objdata" @close="treeClose"></addressTree>
		</div>
		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" border :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
				<el-table-column type="index" align="center" width="45" label="序号"></el-table-column>
				<el-table-column prop="ydbName" align="center" label="淤地坝名称"></el-table-column>
				<el-table-column prop="ydbCode" align="center" label="淤地坝编码"></el-table-column>
				<el-table-column prop="ydbFhyaMc" align="center" label="防汛预案名称"></el-table-column>
        <el-table-column prop="ydbBbh" align="center" label="版本号"></el-table-column>
				<el-table-column prop="ydbBzdw" align="center" label="编制单位"></el-table-column>
				<el-table-column prop="ydbBzrq" align="center" label="编制日期"></el-table-column>
        <el-table-column prop="status" align="center" width="85px" label="状态">
          <template slot-scope="scope">
            <p v-if="scope.row.status==1" class="zxfonte">作废</p>
            <p v-if="scope.row.status==0" class="zxfontb"><span class="fa fa-check fafongt"></span>生效</p>
          </template>
        </el-table-column>

				<el-table-column label="操作" width="90" align="center">
					<template slot-scope="scope">
						<el-button type="success" class="tableedit" icon="el-icon-edit" circle @click="edit(scope.row,scope.$index)"></el-button>
						<el-button type="warning" class="tableedit" icon="el-icon-delete" circle @click="deletes(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fye">
			<pagintion @dsydata='DsyData' @dstdata="DstData" :ToTal='total' :pageNums="pageNums"></pagintion>
		</div>
		<reserveplanpopup v-if="dialogVisible == true" :mystate="Addsid" @bjadddata="Bjadddata" @getcancel="Getcancel" @adddata="Adddata"></reserveplanpopup>
	</div>
</template>

<script>
  import { yaList, yaDelete } from "@/api/api";
  import addressTree from '@/components/mangement/addressTree.vue';
	import pagintion from '@/components/mangement/pagintion.vue';
	import reserveplanpopup from '../popup/reserveplanpopup.vue';
	export default {
		data() {
			return {
				dw: '',
				tabledata: [],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 20, //每页多少条数据分页
				pageNum: 1, //当前页
				pageNums: null,
				username: '',
				dw: '',
				dialogVisible: false,
				Addsid: [],
			}
		},

		components: {
      addressTree,
			pagintion,
			reserveplanpopup

		},
		mounted() {
      let params = {
      	pageSize: this.pageSize,
      	pageNum: this.pageNum,
      }
      this.list(params);
		},
		methods: {
      //调用接口获得防汛预案列表
      list(params) {
      	yaList(params).then((res) => {
          this.total = res.total;
          this.tabledata = res.data;
      	})
      },
			Getcancel(data) {
				this.dialogVisible = data.dialogVisible;
			},
			addClick() {
        this.Addsid = [];
        this.dialogVisible = true;
        this.Addsid.push('xz');
			},
			Bjadddata(data) {
        this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
			},
			Adddata(data) {
        this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
			},
      edit(row, index) {
        this.Addsid = [];
        this.dialogVisible = true;
        this.Addsid.push('bj', row);
      },
      deletes(row, index) {
      	this.$confirm('确定删除当前用户吗?此操作将永久删除, 是否继续?', '提示', {
      		confirmButtonText: '确定',
      		cancelButtonText: '取消',
      		type: 'warning'
      	}).then(action => {
      		if(action === 'confirm') {
            let ids = [];
            ids.push(row.id);
      			yaDelete(ids).then((res) => {
      				if(res.code == 200) {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      					let params = {
      						pageSize: this.pageSize,
      						pageNum: this.pageNum,
      					}
      					this.list(params)
      				} else {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      				}
      			})
      		}
      	}).catch(() => {
      		this.$message({
      			message: '已取消',
      			type: 'warning'
      		});
      	});
      },
      treeClose() {
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        }
        this.list(params)
      },
      objdata(data) {
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbCode: data.ydbCode
        }
        this.list(params)
      },
      DsyData(data) { //多少页
      	this.pageNum = data.dsy;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,
      	}
        this.list(params)
      },
      DstData(data) { //多少条
      	this.pageSize = data.dst;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,
      	}
        this.list(params)
      },
		},
	}
</script>

<style scoped>
	@import url('../../../common/css/mangementall.css');
	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}

	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;
		font-size: 14px;
	}
</style>
